export default __webpack_public_path__ + "static/media/left.e24006fd.svg";